"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.newILendingPoolAddressesProvider = exports.ABI = void 0;
exports.ABI = [
    {
        inputs: [],
        name: "getLendingPool",
        outputs: [{ internalType: "address", name: "", type: "address" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [{ internalType: "address", name: "_pool", type: "address" }],
        name: "setLendingPoolImpl",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getLendingPoolCore",
        outputs: [{ internalType: "address payable", name: "", type: "address" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address", name: "_lendingPoolCore", type: "address" },
        ],
        name: "setLendingPoolCoreImpl",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getLendingPoolConfigurator",
        outputs: [{ internalType: "address", name: "", type: "address" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address", name: "_configurator", type: "address" },
        ],
        name: "setLendingPoolConfiguratorImpl",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getLendingPoolDataProvider",
        outputs: [{ internalType: "address", name: "", type: "address" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [{ internalType: "address", name: "_provider", type: "address" }],
        name: "setLendingPoolDataProviderImpl",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getLendingPoolParametersProvider",
        outputs: [{ internalType: "address", name: "", type: "address" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address", name: "_parametersProvider", type: "address" },
        ],
        name: "setLendingPoolParametersProviderImpl",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getTokenDistributor",
        outputs: [{ internalType: "address", name: "", type: "address" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address", name: "_tokenDistributor", type: "address" },
        ],
        name: "setTokenDistributor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getFeeProvider",
        outputs: [{ internalType: "address", name: "", type: "address" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address", name: "_feeProvider", type: "address" },
        ],
        name: "setFeeProviderImpl",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getLendingPoolLiquidationManager",
        outputs: [{ internalType: "address", name: "", type: "address" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [{ internalType: "address", name: "_manager", type: "address" }],
        name: "setLendingPoolLiquidationManager",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getLendingPoolManager",
        outputs: [{ internalType: "address", name: "", type: "address" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address", name: "_lendingPoolManager", type: "address" },
        ],
        name: "setLendingPoolManager",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getPriceOracle",
        outputs: [{ internalType: "address", name: "", type: "address" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address", name: "_priceOracle", type: "address" },
        ],
        name: "setPriceOracle",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getLendingRateOracle",
        outputs: [{ internalType: "address", name: "", type: "address" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address", name: "_lendingRateOracle", type: "address" },
        ],
        name: "setLendingRateOracle",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
function newILendingPoolAddressesProvider(web3, address) {
    return new web3.eth.Contract(exports.ABI, address);
}
exports.newILendingPoolAddressesProvider = newILendingPoolAddressesProvider;
//# sourceMappingURL=ILendingPoolAddressesProvider.js.map